import React from 'react';

type RadialSpinnerProps = {
  className?: string;
  size?: number | string;
};

export default function RadialSpinner({
  className = 'w-10 h-10 text-slate-500/80',
}: RadialSpinnerProps) {
  return (
    <svg
      className={`animate-spin shrink-0 ${className}`}
      viewBox="0 0 38 38"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      aria-label="Loading..."
      role="status"
    >
      <g>
        <rect x="17.5" y="2" width="3" height="8" rx="1.5" opacity="1" />
        <rect x="17.5" y="2" width="3" height="8" rx="1.5" opacity="0.92" transform="rotate(30 19 19)" />
        <rect x="17.5" y="2" width="3" height="8" rx="1.5" opacity="0.83" transform="rotate(60 19 19)" />
        <rect x="17.5" y="2" width="3" height="8" rx="1.5" opacity="0.75" transform="rotate(90 19 19)" />
        <rect x="17.5" y="2" width="3" height="8" rx="1.5" opacity="0.67" transform="rotate(120 19 19)" />
        <rect x="17.5" y="2" width="3" height="8" rx="1.5" opacity="0.58" transform="rotate(150 19 19)" />
        <rect x="17.5" y="2" width="3" height="8" rx="1.5" opacity="0.5" transform="rotate(180 19 19)" />
        <rect x="17.5" y="2" width="3" height="8" rx="1.5" opacity="0.42" transform="rotate(210 19 19)" />
        <rect x="17.5" y="2" width="3" height="8" rx="1.5" opacity="0.33" transform="rotate(240 19 19)" />
        <rect x="17.5" y="2" width="3" height="8" rx="1.5" opacity="0.25" transform="rotate(270 19 19)" />
        <rect x="17.5" y="2" width="3" height="8" rx="1.5" opacity="0.17" transform="rotate(300 19 19)" />
        <rect x="17.5" y="2" width="3" height="8" rx="1.5" opacity="0.08" transform="rotate(330 19 19)" />
      </g>
    </svg>
  );
}
